<template>
  <div>

    <el-table :data="ClientList" v-loading="loading">
      <el-table-column prop="user_id" label="客户ID"/>
      <el-table-column prop="user_id" width="50px">
        <template slot-scope="s">
          <el-image :src="s.row.agent_avatar || ''" style="width: 40px; height: 40px;"/>
        </template>
      </el-table-column>
      <el-table-column prop="agent_nickname" label="代理人昵称">
        <template slot-scope="scope">{{ scope.row.agent_nickname }}</template>
      </el-table-column>
      <el-table-column prop="agent_id" label="代理人id">
        <template slot-scope="scope">
          <el-link
                  :href="'#/agent/detail/' + scope.row.agent_id"
                  type="primary"
                  target="_blank"
          >{{ scope.row.agent_id }}
          </el-link>
        </template>
      </el-table-column>

      <el-table-column prop="name" label="姓名"/>
      <el-table-column prop="gender"
                       label="性别"
                       :formatter="(_, _1, v) => { return v == 0 ? '女' : '男' }"></el-table-column>
      <el-table-column prop="mobile" width="150px" label="手机号"/>
      <el-table-column prop="birthday" label="生日"/>
      <el-table-column prop="initials" label="拼音缩写"/>
      <el-table-column prop="remarks" width="150px" label="备注"/>
      <el-table-column prop="time" width="150px" label="时间"/>
      <el-table-column prop="deleted" label="状态" :formatter="function(r, c, v, i) { return !v ? '有效' : '删除' }" />
    </el-table>

    <page-bar :currentPageCount="ClientList.length" @page-changed="loadData"></page-bar>
  </div>
</template>

<script>
    import PageBar from "../ui/PageBar";
    import request from "../../api/request";

    export default {
        name: "ClientList",
        components: {
            PageBar
        },
        data() {
            return {
                ClientList: [],
                loading: false,

            };
        },
        created() {
            this.loadData([0, 10]);

        },
        methods: {

            async loadData(range) {
                request.agent
                    .post("client_get_list", {
                        filter: this.filter,
                        range: range,
                        sort: {"id": true}
                    })
                    .then(r => {
                        this.ClientList = r.data.list;
                        this.loading = false;
                    });
            }
        }
    };
</script>